module.exports = require("hat");